(() => {
  const notification = document.querySelector('cart-notification');
  const offer = notification?.querySelector('[data-celestera-offer]');
  const productContainer = notification?.querySelector('#cart-notification-product');
  if (!notification || !offer || !productContainer) return;

  // The promotion ends at midnight in the shop's +08:00 time zone.
  if (Date.now() >= Date.parse('2026-11-01T00:00:00+08:00')) return;

  const message = offer.querySelector('[data-celestera-offer-message]');
  const recommendations = offer.querySelector('[data-celestera-recommendations]');
  const recommendationList = offer.querySelector('[data-celestera-recommendation-list]');
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  let requestNumber = 0;

  const getRecommendations = async (productId, intent) => {
    const url = new URL(`${root}recommendations/products.json`, window.location.origin);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', intent);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return [];
    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  };

  const makeCard = (product) => {
    const productUrl = new URL(product.url, window.location.origin);
    if (productUrl.origin !== window.location.origin) return null;

    const link = document.createElement('a');
    link.className = 'celestera-offer__product';
    link.href = productUrl.href;

    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 64;
      image.height = 64;
      link.append(image);
    }

    const title = document.createElement('span');
    title.textContent = product.title;
    link.append(title);
    return link;
  };

  const update = async () => {
    const currentRequest = ++requestNumber;
    offer.hidden = false;
    message.textContent = 'Add another piece and save on your order.';
    recommendations.hidden = true;
    recommendationList.replaceChildren();

    try {
      const cartResponse = await fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Cart unavailable');
      const cart = await cartResponse.json();
      if (currentRequest !== requestNumber) return;
      if (cart.item_count < 1) {
        offer.hidden = true;
        return;
      }

      if (cart.item_count === 1) {
        message.textContent = 'Add one more piece to unlock 5% off.';
      } else if (cart.item_count === 2) {
        message.textContent = '5% off unlocked. Add one more piece for 10% off.';
      } else {
        message.textContent = '10% off unlocked on your jewelry.';
      }

      const productId = productContainer.querySelector('[data-celestera-product-id]')?.dataset.celesteraProductId;
      if (!productId) return;

      const inCart = new Set(cart.items.map((item) => String(item.product_id)));
      const complementary = await getRecommendations(productId, 'complementary');
      const related = complementary.filter((product) => !inCart.has(String(product.id))).length < 2
        ? await getRecommendations(productId, 'related')
        : [];
      if (currentRequest !== requestNumber) return;

      const seen = new Set();
      const suggested = [...complementary, ...related].filter((product) => {
        if (!product.available || inCart.has(String(product.id)) || seen.has(product.id)) return false;
        seen.add(product.id);
        return true;
      }).slice(0, 2);

      const cards = suggested.map(makeCard).filter(Boolean);
      recommendationList.append(...cards);
      recommendations.hidden = cards.length === 0;
    } catch (error) {
      // Keep the offer and catalog link available if suggestions cannot load.
    }
  };

  new MutationObserver(update).observe(productContainer, { childList: true });
})();

